import React, { useState, useEffect } from 'react';
import { Container } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import Login from './Login';
import Register from './Register';
const Auth = () => {
  const [showLogin, setShowLogin] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  // Set the form based on the route
  useEffect(() => {
    if (location.pathname === '/login') {
      setShowLogin(true);
    } else if (location.pathname === '/register') {
      setShowLogin(false);
    }
  }, [location.pathname]);
  const toggleForm = () => {
    if (showLogin) {
      navigate('/register');
    } else {
      navigate('/login');
    }
  };
  return (
    <Container maxWidth="xl" sx={{ px: { xs: 0, sm: 2 } }}>
      {showLogin ? (
        <Login switchToRegister={toggleForm} />
      ) : (
        <Register switchToLogin={toggleForm} />
      )}
    </Container>
  );
};
export default Auth;
